import changeAcceptedSC from './scheduleChangeAcceptSchema';
import promotionClickSC from './scheduleChangePromotionClickSchema';
import promotionImpressionSC from './scheduleChangePromotionImpression';

export default { changeAcceptedSC, promotionClickSC, promotionImpressionSC };
